/* LottieEditorial — thin wrapper around lottie-react with editorial defaults.

   - Respects `prefers-reduced-motion` synchronously: returns the fallback
     (or null) instead of mounting the player. No memory hit for users who
     opted out of motion.
   - `onComplete` is honored for one-shot use (success microinteractions).
   - Strokes inside the JSON should be authored in champagne gold #C9A961
     (0.788, 0.663, 0.38) — pre-baked in our hand-crafted assets.
*/
import { useMemo } from "react";
import Lottie from "lottie-react";

function prefersReducedMotion() {
  return (
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
}

export default function LottieEditorial({
  animation,
  size = 140,
  loop = true,
  autoplay = true,
  onComplete,
  reducedMotionFallback = null,
  className,
  "data-testid": testid,
}) {
  const rm = useMemo(() => prefersReducedMotion(), []);
  if (rm) return reducedMotionFallback;
  if (!animation) return reducedMotionFallback;

  return (
    <div
      className={className}
      style={{ width: size, height: size, display: "inline-block" }}
      data-testid={testid}
    >
      <Lottie
        animationData={animation}
        loop={loop}
        autoplay={autoplay}
        onComplete={onComplete}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
}
